/* ============================================================================
   KeldCo Solar Cam Pro 3.0 -- redesign behaviour.

   Ported by hand from the <script> block in redesign/solar-cam-3-redesign.html.
   This file is NOT generated: the redesign runs as one IIFE over a page where
   every element is guaranteed to exist, which is not true in a theme where any
   section can be switched off in the editor. So each behaviour here:

     - finds its own root and returns quietly if that section is not on the page
     - marks the root with data-kc3-init so it is never bound twice
     - re-runs on shopify:section:load, for the theme editor

   Pricing note: TIERS and TFOPT are the redesign's hardcoded figures. They are
   read from the #kc3-buybox-data JSON block when the buy box renders one, so
   wiring Kaching Bundles up is a change to that Liquid, not to this file.
   ========================================================================== */
(function () {
  'use strict';

  if (window.KC3) return; // a duplicate <script> must not bind everything twice

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };
  var money = function (n, c) {
    return '$' + n.toLocaleString('en-AU', {
      minimumFractionDigits: c === 0 ? 0 : 2,
      maximumFractionDigits: c === 0 ? 0 : 2
    });
  };
  var trim = function (m) { return m.replace(/\.00$/, ''); };

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" '
    + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>';

  /* Tap fix 4 Oct 2026: open the cart drawer only once it holds the NEW cart.
     'cart:refresh' makes Impact refetch the drawer section and replace its
     children asynchronously, but drawer.show() used to run in the same tick,
     so a first add opened a drawer saying "Your cart is empty" (or the old
     total) for the length of that fetch -- 0.5-1s on 4G in emulation, longer
     on a weak signal -- and shoppers tapped Add again. Now: dispatch the
     refresh, wait for the drawer's children to be replaced (a direct
     childList mutation on #cart-drawer), then show. Ceiling 2.5s so a dropped
     or held redraw (kc-cart's replace guard) can never strand the shopper.
     If theme.js has not defined <cart-drawer> yet (an early tap on a cold
     load), wait up to 4s for it instead of falling straight back to the
     button label. `done` runs when the drawer is shown (or not available),
     so the button's busy state lasts until there is something to see. */
  /* Fetch the drawer section ourselves and swap its children -- the same thing the theme's
     cart:refresh handler does. Resolves when done (or failed); never rejects. */
  function selfRefresh(drawer) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var redrawn = false;
    var mo2 = new MutationObserver(function () { redrawn = true; });
    mo2.observe(drawer, { childList: true });
    return fetch(root + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        mo2.disconnect();
        if (redrawn) return; /* the theme got there first */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer');
        if (!fresh) return;
        drawer.replaceChildren.apply(drawer, Array.prototype.map.call(fresh.childNodes, function (n) { return document.importNode(n, true); }));
      })
      .catch(function (e) { mo2.disconnect(); console.error('[kc3] drawer self-refresh failed', e); });
  }

  /* Swap the drawer's children from a bundled section render (cart/add.js `sections`).
     Returns true when it swapped. */
  function swapDrawer(drawer, html) {
    try {
      if (!html) return false;
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer');
      if (!fresh) return false;
      drawer.replaceChildren.apply(drawer, Array.prototype.map.call(fresh.childNodes, function (n) { return document.importNode(n, true); }));
      return true;
    } catch (e) { return false; }
  }
  function drawerHtml(json) { return json && json.sections && json.sections['cart-drawer']; }
  /* ATC speed 20 Oct 2026: the add call also renders sections/kc-cart-json, so the
     full cart comes back in the same response. Null when missing or unparsable, and
     every caller then falls back to the old path (swap + 'cart:refresh'). */
  function cartJson(json) {
    try {
      var h = json && json.sections && json.sections['kc-cart-json'];
      if (!h) return null;
      var n = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-kc-cart-json]');
      var c = n && JSON.parse(n.textContent);
      return c && typeof c.item_count === 'number' && Array.isArray(c.items) ? c : null;
    } catch (e) { return null; }
  }

  function refreshThenShowDrawer(done, fallback, html, cart) {
    var drawer = document.getElementById('cart-drawer');
    function finish(ok) { if (!ok && fallback) fallback(); if (done) done(); }
    if (!drawer) { document.dispatchEvent(new CustomEvent('cart:refresh')); finish(false); return; }
    function go() {
      if (typeof drawer.show !== 'function') { document.dispatchEvent(new CustomEvent('cart:refresh')); finish(false); return; }
      var shown = false, timer = 0, mo = null;
      function open() {
        if (shown) return;
        shown = true;
        if (mo) mo.disconnect();
        clearTimeout(timer); clearTimeout(hard);
        try { drawer.show(); } catch (e) { console.error('[kc3] drawer.show failed', e); }
        finish(true);
      }
      /* The drawer only opens once it holds the new cart, so the shopper never sees
         "Your cart is empty" (iPhone emulation: 1-15s of empty drawer before this). If the
         theme's cart:refresh redraw hasn't landed after 1.2s (on a cold load its listener may
         not be bound yet), fetch the section ourselves, then open. Hard ceiling 6s. The
         button keeps its busy spinner until the drawer opens. */
      /* Fast path: the add call already rendered the drawer (one round trip). Open now,
         then let the theme's own cart:refresh update the count. */
      var hard = 0;
      if (swapDrawer(drawer, html)) {
        open();
        /* ATC speed 20 Oct 2026: when the same response also carried the cart
           (sections/kc-cart-json), give the theme its own 'cart:change' payload instead
           of 'cart:refresh'. The count, free-ship bar and theme cart cache update from
           it, and nothing refetches the drawer section or /cart.js. Without it, the old
           'cart:refresh' path runs unchanged. */
        if (cart) {
          try {
            var sec = drawer.closest('.shopify-section');
            var sections = {}; sections['cart-drawer'] = html;
            if (sec) sections[sec.id.replace('shopify-section-', '')] = html;
            cart.sections = sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            return;
          } catch (e) { console.error('[kc3] bundled cart:change failed', e); }
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      hard = setTimeout(open, 6000);
      if (window.MutationObserver) {
        mo = new MutationObserver(function () { setTimeout(open, 0); });
        mo.observe(drawer, { childList: true });
      }
      timer = setTimeout(function () { selfRefresh(drawer).then(open); }, window.MutationObserver ? 1200 : 0);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
    if (typeof drawer.show === 'function' || !window.customElements || !customElements.whenDefined) { go(); return; }
    var waited = false;
    var t = setTimeout(function () { if (!waited) { waited = true; go(); } }, 4000);
    customElements.whenDefined('cart-drawer').then(function () { if (!waited) { waited = true; clearTimeout(t); go(); } });
  }

  /* Run `fn` once per root element. Returns false when there is nothing to do. */
  function once(root, fn) {
    if (!root || root.dataset.kc3Init) return false;
    root.dataset.kc3Init = '1';
    fn(root);
    return true;
  }

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[kc3] could not parse #' + id + ', using built-in defaults', e);
      return fallback;
    }
  }

  var DEFAULT_TIERS = [
    { q: 1, each: 329.00, total: 329.00, was: 329.00, save: 0, tag: '' },
    { q: 2, each: 320.78, total: 641.56, was: 658.00, save: 16.44, tag: '' },
    { q: 3, each: 312.55, total: 937.65, was: 987.00, save: 49.35, tag: 'Most popular' },
    { q: 4, each: 304.33, total: 1217.32, was: 1316.00, save: 98.68, tag: '' },
    { q: 5, each: 296.10, total: 1480.50, was: 1645.00, save: 164.50, tag: '' },
    { q: 6, each: 279.65, total: 1677.90, was: 1974.00, save: 296.10, tag: '', label: '6+' }
  ];
  /* `id` is the Micro TF Card variant. Without it a size prices in the buy box
     but never reaches the cart, which charges the customer less than the button
     said -- so addToCart refuses to send a selection it cannot price. */
  var DEFAULT_TFOPT = [
    { s: '64GB', p: 39, id: 47470136099090 },
    { s: '128GB', p: 73, id: 47470136131858 },
    { s: '256GB', p: 153, n: 'Solar Cam Pro 3.0 only', id: 51776734757138 },
    { s: '512GB', p: 299, n: 'Solar Cam Pro 3.0 only', id: 51776736166162 }
  ];

  /* ---------- buy box: tiers, TF cards, price, CTA, sticky bar ---------- */
  function buybox() {
    once($('#s-main'), function (root) {
      var tiersEl = $('#tiers', root);
      if (!tiersEl) return;

      var data = readJSON('kc3-buybox-data', {});
      var TIERS = data.tiers && data.tiers.length ? data.tiers : DEFAULT_TIERS;
      var TFOPT = data.tf && data.tf.length ? data.tf : DEFAULT_TFOPT;
      /* What the thing being counted is called. Every KC3 page but Solar Cam Pro
         3.0 sells something else -- a doorbell, an indoor camera -- so the
         noun is data, not a string in here. */
      var NOUN = data.noun || 'camera';
      var NOUNS = data.nounPlural || (NOUN + 's');
      var TFNOTE = data.tfNote || 'One card per ' + NOUN + '.';
      var word = function (q) { return q === 1 ? NOUN : NOUNS; };

      var qty = 1, addon = false, tfSel = [0];

      /* The ladder is a price break, not a limit. Any quantity is allowed; the
         applicable tier is the highest one whose q is <= the quantity, so
         ordering 9 pays the 6+ unit price on all nine rather than being capped
         at six. Only quantities that land exactly on a rung use that rung's
         published total -- past the top rung we multiply the unit price out. */
      function tierAt(q) {
        var t = TIERS[0];
        for (var i = 0; i < TIERS.length; i++) if (TIERS[i].q <= q) t = TIERS[i];
        return t;
      }
      function totalAt(q) {
        var t = tierAt(q);
        return q === t.q ? t.total : Math.round(t.each * q * 100) / 100;
      }
      function wasAt(q) {
        var t = tierAt(q);
        return q === t.q ? t.was : Math.round(TIERS[0].each * q * 100) / 100;
      }
      var cardQty = 1, userSetQty = false, lastCamQ = 1;

      var cb = $('#addonCb', root);
      var addonEl = $('#addon', root);
      var addonWrap = $('.addon-wrap', root);
      var sizesEl = $('#tfSizes', root);
      /* The sticky bar lives in this section but outside #s-main's wrap. */
      var stickySub = $('#stickySub');
      var stickyBtn = $('#stickyBtn');

      TIERS.forEach(function (t, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tier' + (i === 0 ? ' is-active' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', i === 0);
        /* Every card renders the same five rows, including the ones with
           nothing to put in them, so the prices line up across the grid and can
           be scanned down a column. The tag row and the savings badge are
           emptied rather than dropped -- dropping them makes rows different
           heights and the numbers stop aligning. */
        b.innerHTML =
            '<span class="tier__tag">' + (t.tag ? '<b>' + t.tag + '</b>' : '') + '</span>'
          + '<span class="tier__check">' + CHECK + '</span>'
          + '<span class="tier__q">' + (t.label || t.q) + ' ' + word(t.q) + '</span>'
          /* The unit price leads: it is what people compare between tiers. */
          + '<span class="tier__unit">' + trim(money(t.each, 2)) + '<em>each</em></span>'
          /* At one unit the total is the unit price, so the line is hidden
             rather than dropped -- it holds its place so every card stays the
             same height and the prices still line up down the grid. */
          + '<span class="tier__total' + (t.q === 1 ? ' is-none' : '') + '">'
            + trim(money(t.total, 2)) + ' total</span>';
        b.addEventListener('click', function () { qty = t.q; render(); });
        tiersEl.appendChild(b);
      });

      if (cb) cb.addEventListener('change', function () { addon = cb.checked; render(); });

      /* Both steppers -- the one by the CTA and the one in the sticky bar --
         drive the same quantity, so they cannot disagree. Only the floor is
         enforced: there is no ceiling, the top tier's unit price just carries. */
      $$('[data-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          qty = Math.max(1, qty + Number(b.dataset.qtyStep));
          render();
        });
      });

      function buildSizes(q) {
        if (!sizesEl) return;
        if (q !== lastCamQ) { lastCamQ = q; if (!userSetQty) cardQty = q; }
        if (!userSetQty) cardQty = q;
        cardQty = Math.min(cardQty, q);
        while (tfSel.length < cardQty) tfSel.push(tfSel[tfSel.length - 1] || 0);
        tfSel.length = cardQty;
        var h = '<div class="tf-head"><span>How many cards?</span><div class="tf-step">'
          + '<button type="button" data-tf="-1" aria-label="Fewer cards"' + (cardQty <= 1 ? ' disabled' : '') + '>&minus;</button><b>' + cardQty + '</b>'
          + '<button type="button" data-tf="1" aria-label="More cards"' + (cardQty >= q ? ' disabled' : '') + '>+</button></div></div>';
        tfSel.forEach(function (idx, i) {
          h += '<div class="tf-row"><span>Card ' + (i + 1) + '</span><div class="tf-opts">'
            + TFOPT.map(function (o, k) {
              return '<button type="button" class="tf-opt' + (k === idx ? ' is-on' : '') + '" data-card="' + i + '" data-opt="' + k + '"><b>' + o.s + '</b><span>$' + o.p + '</span></button>';
            }).join('')
            + '</div></div>';
        });
        h += '<p class="tf-note">' + TFNOTE + '</p>';
        sizesEl.innerHTML = h;
        $$('[data-tf]', sizesEl).forEach(function (b) {
          b.addEventListener('click', function () {
            cardQty = Math.min(q, Math.max(1, cardQty + +b.dataset.tf));
            userSetQty = true;
            render();
          });
        });
        $$('.tf-opt', sizesEl).forEach(function (b) {
          b.addEventListener('click', function () {
            tfSel[+b.dataset.card] = +b.dataset.opt;
            render();
          });
        });
      }

      function cardsSum() {
        var n = 0;
        for (var i = 0; i < tfSel.length; i++) n += TFOPT[tfSel[i]].p;
        return n;
      }

      function render() {
        var t = tierAt(qty);
        var sel = TIERS.indexOf(t);
        $$('.tier', tiersEl).forEach(function (el, i) {
          el.classList.toggle('is-active', i === sel);
          el.setAttribute('aria-checked', i === sel);
        });
        buildSizes(qty);
        var cards = addon ? cardsSum() : 0;
        var total = totalAt(qty) + cards;
        var now = $('#priceNow', root);
        if (now) now.textContent = trim(money(total, 2));
        var was = $('#priceWas', root), save = $('#priceSave', root);
        if (was && save) {
          if (t.save) {
            was.hidden = false;
            was.textContent = trim(money(wasAt(qty) + cards, 2));
            save.hidden = false;
            save.textContent = 'Save ' + money(wasAt(qty) - totalAt(qty), 0);
          } else {
            was.hidden = true;
            save.hidden = true;
          }
        }
        var ctx = $('#priceCtx', root);
        if (ctx) ctx.textContent = qty > 1 ? ('total for ' + qty + ' ' + NOUNS + ' · incl. GST') : 'AUD · incl. GST';
        var ap = $('#addonPrice', root);
        if (ap) ap.textContent = addon ? ('+' + money(cards, 0) + (cardQty > 1 ? ' · ' + cardQty + ' cards' : ' · 1 card')) : 'from +$39';
        if (sizesEl) sizesEl.hidden = !addon;
        if (addonEl) addonEl.classList.toggle('is-on', addon);
        if (addonWrap) addonWrap.classList.toggle('is-open', addon);
        var amt = $('#ctaAmt', root);
        if (amt) amt.textContent = money(total, 2);
        /* What actually goes in the cart. The tier price above is display only
           -- Kaching's discount function applies it from this quantity. The
           cards are a separate product, so they ride along as their own line
           items, grouped so two 128GB cards are one line of quantity 2. */
        var buy = $('.kc3-buy', root);
        if (buy) {
          buy.dataset.quantity = qty;
          var lines = {}, unpriced = 0;
          if (addon) {
            tfSel.slice(0, cardQty).forEach(function (idx) {
              var opt = TFOPT[idx];
              if (!opt) return;
              if (!opt.id) { unpriced++; return; }
              /* Price and size ride along so the add_to_cart event can report
                 what the cards actually cost, not just how many there were. */
              lines[opt.id] = lines[opt.id] || { quantity: 0, price: opt.p, size: opt.s };
              lines[opt.id].quantity += 1;
            });
          }
          if (unpriced) {
            console.warn('[kc3] ' + unpriced + ' TF card size(s) have no variant id, so they '
              + 'price in the buy box but cannot be added. Set `id` in the section\'s tf_json.');
          }
          buy.dataset.cards = JSON.stringify(Object.keys(lines).map(function (id) {
            /* /cart/add.js ignores the extra keys; the tracking event reads them. */
            return {
              id: Number(id),
              quantity: lines[id].quantity,
              price: lines[id].price,
              title: 'Micro TF card ' + lines[id].size
            };
          }));
          buy.dataset.cardsUnpriced = unpriced;
          /* Kaching discounts by quantity server-side, so the list price on the
             variant is not what the customer pays. Report the tier's figures or
             the Ads conversion value comes in high -- verified 7 Sep 2026:
             list price gave $1,104 against a real cart of $1,054.65. */
          buy.dataset.unitPrice = t.each;
          buy.dataset.unitsTotal = totalAt(qty);
        }
        $$('[data-qty-value]').forEach(function (el) { el.textContent = qty; });
        if (stickySub) stickySub.textContent = qty + ' ' + word(qty)
          + (addon ? ' + ' + cardQty + ' TF card' + (cardQty > 1 ? 's' : '') : '') + ' · ' + money(total, 2);
        if (stickyBtn) stickyBtn.textContent = 'Add to cart · ' + money(total, 2);

        /* Published so the add-to-cart wiring can read the current selection
           without reaching into this closure. See TODO(kaching) in
           sections/kc3-buybox.liquid. */
        root.dispatchEvent(new CustomEvent('kc3:selection', {
          bubbles: true,
          detail: { tier: t, quantity: qty, addon: addon, cards: tfSel.slice(0, cardQty), total: total }
        }));
      }

      render();
    });
  }

  /* ---------- add to cart ----------
     The buy box has no <form action="/cart/add">, because Kaching Bundles and
     Vitals both hunt for one and take it over -- Kaching injected its own
     quantity selector into ours and swallowed the submit.

     Deliberately the smallest request that does the job: a JSON add with no
     bundled sections. Impact's own product-form asks /cart/add.js to render
     `sections` in the same call; that is one round trip instead of three, and
     is worth going back to if this ever needs the speed.

     It is kept simple because the failure that prompted it -- /cart/add.js
     returning an error page -- happened during a Shopify incident on
     6 Sep 2026 that degraded storefront, checkout and admin. So there was
     probably never anything wrong with the bundled-sections call. This version
     has fewer moving parts to go wrong during the next one, and `cart:refresh`
     is Impact's own supported path: the cart drawer re-fetches and re-renders
     itself, and cart-count re-reads from the server.

     The bundle discount needs no help -- it is a server-side Shopify function
     keyed on quantity, verified against the live cart for all six tiers by
     bin/kc3-verify-tiers. */
  function addToCart() {
    once($('.kc3-buy'), function (buy) {
      var button = $('#cta', buy);
      if (!button) return;
      var express = $('#ctaExpress', buy);
      var label = $('#ctaLabel', buy);
      var error = $('#ctaError', buy);
      var busy = false;

      /* The cameras, plus whatever TF cards are selected. */
      function lineItems(buy) {
        var items = [{
          id: Number(buy.dataset.variantId),
          quantity: Number(buy.dataset.quantity) || 1
        }];
        try {
          var cards = JSON.parse(buy.dataset.cards || '[]');
          if (cards.length) items = items.concat(cards);
        } catch (e) {
          console.warn('[kc3] could not read the TF card selection', e);
        }
        return items;
      }

      /* One add path, two endings.

           then: 'drawer'    add, then open the cart drawer (the CTA)
           then: 'checkout'  add, then go to checkout (Buy it now)

         Express checkout is this and not {{ form | payment_button }}, which
         cannot express what this buy box sells: the native button carries one
         variant at the form's quantity, so it would drop the TF-card line and
         miss the cart-level Kaching discount -- charging less than the page
         showed. Adding through the same /cart/add.js call keeps tiers, the
         add-on and the discount, because the cart is what checkout reads.

         Note `fetch` is called unqualified, never captured. assets/kc-cro.js
         wraps window.fetch to stamp the A/B arm onto /cart/add.js line items;
         holding a reference here would route express adds around it and lose
         their attribution. */
      function send(opts) {
        var checkout = !!opts && opts.then === 'checkout';
        var trigger = (opts && opts.from) || (checkout && express ? express : button);

        if (busy) return;
        busy = true;
        trigger.setAttribute('aria-busy', 'true');
        if (error) error.hidden = true;

        if (Number(buy.dataset.cardsUnpriced) > 0) {
          /* The button's total includes a card we cannot add. Adding anyway
             would charge less than it says, which is worse than not adding. */
          if (error) {
            error.textContent = 'That card size is not available to add right now. Pick another size, or uncheck the cards.';
            error.hidden = false;
          }
          busy = false;
          trigger.removeAttribute('aria-busy');
          return;
        }

        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // so Shopify checks inventory
          },
          body: JSON.stringify({ items: lineItems(buy), sections: 'cart-drawer,kc-cart-json' })
        }).then(function (response) {
          /* Read as text first: an error page is not JSON, and "Unexpected
             token" tells nobody anything. */
          return response.text().then(function (text) {
            var json = null;
            try { json = JSON.parse(text); } catch (e) { /* not JSON */ }
            if (!response.ok || !json) {
              throw new Error(
                (json && (json.description || json.message))
                || 'Could not add to cart (' + response.status + ' ' + response.statusText + ')'
              );
            }
            return json;
          });
        }).then(function (json) {
          /* Both endings track. The express path skipping this would bias the
             add_to_cart rate that the whole change is measured on. */
          trackAddToCart(buy);
          signalFormSubmit();

          if (checkout) {
            /* Leave `busy` set: the page is going away, and releasing it here
               opens a window where a second tap adds the items again. */
            var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
            window.location.href = root + 'checkout';
            return;
          }

          /* Impact's own "something changed, re-read from the server" signal.
             The cart drawer and the cart count both listen for it. */
          refreshThenShowDrawer(function () {
            busy = false;
            trigger.removeAttribute('aria-busy');
          }, confirmAdded, drawerHtml(json), cartJson(json));
        }).catch(function (e) {
          /* A failed add never navigates: the customer stays on the page with
             the reason, rather than landing on a checkout without their cart. */
          if (error) {
            error.textContent = e.message;
            error.hidden = false;
          }
          console.error('[kc3] add to cart failed', e);
          busy = false;
          trigger.removeAttribute('aria-busy');
        });
      }

      button.addEventListener('click', function () { send({ then: 'drawer' }); });
      if (express) {
        express.addEventListener('click', function () { send({ then: 'checkout' }); });
      }

      /* Sticky ATC must call the same send() path as #cta -- never scroll to
         #s-main. Markup is <button type="button" id="stickyBtn"> (was an
         <a href="#s-main"> fallback that lied on mobile when JS lagged).
         Both buy boxes render #stickyBtn, so this covers the advertorial too. */
      var sticky = $('#stickyBtn');
      if (sticky) {
        sticky.addEventListener('click', function (e) {
          e.preventDefault();
          send({ then: 'drawer', from: sticky });
        });
      }

      /* kc3.js is deferred, so #cta paints and is tappable before any of the
         above exists. The inline script in the buy box section captures taps
         in that window; this is its cue to stop capturing and replay. */
      document.documentElement.setAttribute('data-kc3-atc', '1');
      document.dispatchEvent(new CustomEvent('kc3:ready'));

      /* This buy box has no <form action="/cart/add">, on purpose -- see the
         note at the top of addToCart(). GTM's container fires the Google Ads
         add-to-cart conversion off a Form Submission trigger, which means it
         fires on every other product template and would fire on none of these.
         Verified on 7 Sep 2026: the old template pushes `gtm.formSubmit` and
         calls googleads viewthroughconversion; this one pushed nothing.

         So push the event ourselves, in the GA4 shape, and let the container
         key a Custom Event trigger on `add_to_cart`. Shopify's own Customer
         Events pixel is unaffected either way -- it hooks the Ajax Cart API. */
      function trackAddToCart(buy) {
        try {
          var d = buy.dataset;
          var qty = Number(d.quantity) || 1;
          /* Discounted unit price when a tier is selected; list price otherwise
             (the Perimeter Kit and any other single-SKU page have no ladder). */
          var price = Number(d.unitPrice) || Number(d.price) || 0;
          var unitsTotal = Number(d.unitsTotal);
          if (!isFinite(unitsTotal)) unitsTotal = price * qty;
          var items = [{
            item_id: d.productId,
            item_name: d.productTitle,
            item_brand: d.productVendor || 'KeldCo',
            item_category: d.productType || '',
            item_variant: d.variantTitle || '',
            price: +price.toFixed(2),
            quantity: qty
          }];
          /* The TF cards are separate line items; count them as separate items
             so the reported value matches what actually went in the cart. */
          var cards = JSON.parse(d.cards || '[]');
          var cardsValue = 0;
          cards.forEach(function (c) {
            var p = Number(c.price) || 0;
            cardsValue += p * (Number(c.quantity) || 1);
            items.push({
              item_id: String(c.id),
              item_name: c.title || 'Micro TF card',
              item_brand: 'KeldCo',
              item_category: 'Storage',
              price: p,
              quantity: Number(c.quantity) || 1
            });
          });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: d.currency || 'AUD',
              value: +(unitsTotal + cardsValue).toFixed(2),
              items: items
            }
          });
        } catch (e) {
          /* Tracking must never be the reason an add-to-cart looks broken. */
          console.warn('[kc3] add_to_cart dataLayer push failed', e);
        }
      }

      /* Keeps the EXISTING Google Ads conversion working with no change to the
         GTM container, so nobody has to touch GTM to ship this page.

         The container fires that conversion from a Form Submission trigger.
         This buy box has no <form> (see the note at the top of addToCart), so
         the trigger had nothing to listen to. Measured on the dev server,
         7 Sep 2026: a synthetic submit event fires the same six Ads endpoints
         as the live template -- pagead/form-data, ccm/form-data,
         viewthroughconversion, rmkt/collect and both 1p-user-list calls -- and
         it does so for ANY form. Tested three shapes: action="/cart/add" with
         class="shopify-product-form", a neutral action with that class, and a
         neutral action with no class. All three fired the identical set, so the
         trigger filters on neither the action nor the class.

         That lets us use an action Kaching Bundles and Vitals cannot match.
         Both hunt for form[action*="/cart/add"] and would take a real one over
         -- Kaching injected its own quantity selector into our buy box and
         swallowed the submit, which is why there is no form here in the first
         place. "/kc3-add-to-cart" does not contain "/cart/add", so neither app
         sees it, and the node is removed on the next tick regardless.

         The GA4 add_to_cart push above is the better long-term signal. This is
         here so the page can ship without a container change; once a Custom
         Event trigger on add_to_cart exists, this can go. */
      function signalFormSubmit() {
        try {
          var f = document.createElement('form');
          f.setAttribute('action', '/kc3-add-to-cart');
          f.setAttribute('method', 'post');
          f.setAttribute('aria-hidden', 'true');
          f.style.display = 'none';
          f.addEventListener('submit', function (e) { e.preventDefault(); });
          document.body.appendChild(f);
          f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 0);
        } catch (e) {
          /* Tracking must never be the reason an add-to-cart looks broken. */
          console.warn('[kc3] could not signal the form submit to GTM', e);
        }
      }

      function confirmAdded() {
        /* No cart drawer on this template, so nothing visible happens on
           success -- say so on the button itself. */
        if (!label) return;
        var sticky = $('.sticky__t');
        var added = (sticky && sticky.dataset.addedLabel) || 'Added to cart';
        var was = label.textContent;
        label.textContent = added;
        setTimeout(function () { label.textContent = was; }, 2200);
      }
    });
  }

  /* ---------- delivery timeline ---------- */
  function delivery() {
    once($('.shipline'), function (root) {
      var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var fmt = function (d) { return ('0' + d.getDate()).slice(-2) + ' ' + M[d.getMonth()]; };
      var day = 864e5, now = new Date();
      var d = function (n) { return fmt(new Date(+now + n * day)); };
      var set = function (id, text) { var el = $(id, root); if (el) el.textContent = text; };
      set('#delWindow', d(4) + ' – ' + d(6));
      set('#delD0', fmt(now));
      set('#delD1', d(1) + ' – ' + d(2));
      set('#delD2', d(4) + ' – ' + d(6));
    });
  }

  /* ---------- gallery ---------- */
  function gallery() {
    once($('#gallery'), function (root) {
      var imgs = $$('.gallery__main img', root);
      var thumbs = $$('#thumbs button', root);
      if (!imgs.length) return;
      var gi = 0;
      function go(n) {
        gi = (n + imgs.length) % imgs.length;
        imgs.forEach(function (im, i) { im.classList.toggle('is-active', i === gi); });
        thumbs.forEach(function (b, i) { b.classList.toggle('is-active', i === gi); });
      }
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
      $$('[data-gal]', root).forEach(function (b) {
        b.addEventListener('click', function () { go(gi + +b.dataset.gal); });
      });
      var sx = 0, gm = $('.gallery__main', root);
      if (!gm) return;
      gm.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(gi + (dx < 0 ? 1 : -1));
      });
    });
  }

  /* ---------- horizontal rails ---------- */
  function rails() {
    $$('[data-rail-for]').forEach(function (c) {
      once(c, function () {
        var track = document.getElementById(c.dataset.railFor);
        if (!track) return;
        $$('button', c).forEach(function (b) {
          b.addEventListener('click', function () {
            var card = track.firstElementChild;
            if (!card) return;
            var w = card.getBoundingClientRect().width + 18;
            track.scrollBy({ left: w * +b.dataset.dir, behavior: 'smooth' });
          });
        });
      });
    });
  }

  /* ---------- play clips only while they are on screen ---------- */
  function clips() {
    if (!('IntersectionObserver' in window)) return;
    var vids = $$('#s-footage video, #s-app video, #s-setup video, #s-hero-statement video').filter(function (v) { return !v.dataset.kc3Init; });
    if (!vids.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.3 });
    vids.forEach(function (v) { v.dataset.kc3Init = '1'; io.observe(v); });
  }

  /* ---------- Vimeo facade: no iframe until someone asks for one ---------- */
  function video() {
    once($('#setupVideo'), function (sv) {
      var play = $('.video__play', sv);
      if (!play) return;
      play.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://player.vimeo.com/video/' + sv.dataset.vimeo + '?autoplay=1&badge=0&title=0&byline=0&portrait=0';
        f.allow = 'autoplay; fullscreen; picture-in-picture';
        f.title = sv.dataset.title || 'Setup video';
        sv.innerHTML = '';
        sv.appendChild(f);
      });
    });
  }

  /* ---------- cost calculator ---------- */
  function cost() {
    once($('#costCalc'), function (cc) {
      var dd = cc.dataset, cams = 1, yrs = 5;
      var A = { p: +dd.aPrice, f: +dd.aFee }, B = { p: +dd.bPrice, f: +dd.bFee }, C = { p: +dd.cPrice };
      /* Rivals and the noun differ per product, so both are markup, not code. */
      var RIVALS = dd.rivals || 'Ring and Arlo';
      var LEADER = dd.leader || 'Ring';
      var UNIT = dd.unit || 'camera', UNITS = dd.unitPlural || (UNIT + 's');
      /* The claim that closes the savings line. Not every product in the range
         out-resolves its rivals, so this must never be hardcoded. */
      var CLAIM = dd.claim || ', with better resolution and no lock-in.';
      function calc() {
        var aSub = A.f * 12 * yrs * cams, bSub = B.f * 12 * yrs * cams;
        var aCam = A.p * cams, bCam = B.p * cams, cTot = C.p * cams;
        var aTot = aCam + aSub, bTot = bCam + bSub;
        $('#camsOut', cc).textContent = cams;
        $('#yrsOut', cc).textContent = yrs;
        var s1 = aTot - cTot, s2 = bTot - cTot;
        var lo = Math.min(s1, s2), hi = Math.max(s1, s2);
        if (lo > 0) {
          $('#saveLbl', cc).textContent = 'You save up to';
          $('#saveOut', cc).textContent = money(hi, 0);
          $('#saveSub', cc).textContent = 'over ' + yrs + ' year' + (yrs > 1 ? 's' : '') + ' vs ' + RIVALS + CLAIM;
        } else {
          var months = Math.ceil((C.p - A.p) / A.f);
          $('#saveLbl', cc).textContent = 'Pays for itself';
          $('#saveOut', cc).textContent = months + ' months';
          $('#saveSub', cc).textContent = 'vs ' + LEADER + ' — after that it\'s $0/month forever, while their subscriptions keep charging.';
        }
        /* Bar heights start proportional. A flat 90px floor used to squash the
           two cheaper bars to within a pixel of each other, so a rival 13%
           dearer read as the same price; the scale grows instead until the
           shortest bar is legible. On a phone that scale ran away -- a 4x
           price gap put the dearest bar past 450px -- so it is capped there,
           and the floor and the step shrink to match. */
        var max = Math.max(aTot, bTot, cTot), min = Math.min(aTot, bTot, cTot);
        var narrow = window.innerWidth < 760;
        var H = narrow ? 300 : Math.max(330, Math.min(560, Math.round(112 * max / (min || 1))));
        var GAP = narrow ? 48 : 64, FLOOR = narrow ? 96 : 112;
        var set = function (k, tot, cam, sub) {
          var bar = $('[data-bar="' + k + '"]', cc);
          if (!bar) return;
          $('.bar__total', bar).textContent = money(tot, 0);
          $('.cam-v', bar).textContent = money(cam, 0);
          var sv2 = $('.sub-v', bar);
          if (sv2) sv2.textContent = money(sub, 0);
          var col = $('.bar__col', bar);
          col.style.height = Math.round(H * tot / max) + 'px';
          var segs = $$('.bar__seg', col);
          if (segs.length > 1) {
            /* A rival on no plan has no subscription to draw. The segment has a
               min-height, so flex:0 was still painting a "Subscription $0" band. */
            segs[0].style.display = sub > 0 ? '' : 'none';
            segs[0].style.flex = sub;
          }
          /* The camera segment fills whatever is left -- set outside the branch
             because a no-plan rival renders with this segment on its own, and
             without a flex it collapses to its text and sinks to the bottom. */
          segs[segs.length - 1].style.flex = cam;
        };
        set('a', aTot, aCam, aSub);
        set('b', bTot, bCam, bSub);
        set('c', cTot, cTot, 0);
        /* Two rivals priced within a few per cent of each other draw within a
           few pixels of each other, and the cheaper-looking one reads as "same
           price". Walk the bars shortest to tallest: lift the shortest to the
           floor so its label fits, then force a minimum visible step, capping
           at H. Bars already well apart are untouched, and every bar still
           carries its real total above it. */
        var cols = [['a', aTot], ['b', bTot], ['c', cTot]]
          .sort(function (x, y) { return x[1] - y[1]; })
          .map(function (pr) { var el = $('[data-bar="' + pr[0] + '"]', cc); return el && $('.bar__col', el); })
          .filter(Boolean);
        var hs = cols.map(function (el) { return parseFloat(el.style.height) || 0; });
        hs[0] = Math.max(hs[0], FLOOR);
        for (var i = 1; i < hs.length; i++) {
          hs[i] = Math.min(H, Math.max(hs[i], hs[i - 1] + GAP));
        }
        cols.forEach(function (el, i) { el.style.height = Math.round(hs[i]) + 'px'; });
        /* The bars are bottom-aligned as whole units, so a name wrapping onto a
           second or third line lifted that column off the shared baseline.
           Level the name row and every bar stands on the same line. */
        var names = $$('.bar__name', cc);
        names.forEach(function (n) { n.style.minHeight = ''; });
        var tallest = 0;
        names.forEach(function (n) { tallest = Math.max(tallest, n.offsetHeight); });
        names.forEach(function (n) { n.style.minHeight = tallest + 'px'; });
        [['a', aTot], ['b', bTot], ['c', cTot]]
          .sort(function (x, y) { return x[1] - y[1]; })
          .forEach(function (pr, idx) {
            var bar = $('[data-bar="' + pr[0] + '"]', cc);
            if (bar) bar.style.order = idx;
          });
        $('#costSummary', cc).textContent = cams + ' ' + (cams === 1 ? UNIT : UNITS) + ' over ' + yrs + ' year' + (yrs > 1 ? 's' : '');
      }
      $$('[data-step]', cc).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.dataset.step === 'cams') cams = Math.min(20, Math.max(1, cams + +b.dataset.d));
          else yrs = Math.min(15, Math.max(1, yrs + +b.dataset.d));
          calc();
        });
      });
      calc();
      /* H, the floor and the step all depend on viewport width, and the name
         row is measured. Recalculate on resize -- a phone rotating crosses the
         breakpoint -- debounced so dragging a desktop window stays cheap. */
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(calc, 150);
      });
    });
  }

  /* ---------- [data-stars] -> five SVGs ---------- */
  var STAR = '<svg class="star" viewBox="0 0 20 20"><path d="M10 1.5l2.6 5.5 6 .8-4.4 4.2 1.1 5.9L10 15l-5.3 2.9 1.1-5.9L1.4 7.8l6-.8z"/></svg>';
  function stars() {
    $$('[data-stars]').forEach(function (st) {
      once(st, function () {
        var n = +st.dataset.stars, h = '';
        for (var i = 0; i < 5; i++) {
          h += i < n ? STAR : STAR.replace('class="star"', 'class="star" style="fill:#d2d2d7"');
        }
        st.innerHTML = h;
      });
    });
  }

  /* ---------- FAQ: highlight the topic you are reading ---------- */
  function faq() {
    once($('#faqNav'), function (nav) {
      if (!('IntersectionObserver' in window)) return;
      var links = $$('a', nav);
      var groups = $$('.faq__group');
      var fo = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (l) {
            l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
          });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      groups.forEach(function (g) { fo.observe(g); });
    });
  }

  /* ---------- app rail: drop the fade once it is scrolled out ---------- */
  function appRail() {
    once(document.getElementById('appRail'), function (ar) {
      var af = $('.app__fade');
      if (!af) return;
      var chk = function () { af.classList.toggle('is-off', ar.scrollLeft >= ar.scrollWidth - ar.clientWidth - 10); };
      ar.addEventListener('scroll', chk, { passive: true });
      chk();
    });
  }

  /* ---------- sticky add-to-cart bar ---------- */
  var stickyScroll = null;
  var stickyIO = null;
  function sticky() {
    /* Listeners outlive a section re-render in the theme editor -- drop the
       old ones before binding against the new DOM. Do NOT gate on once(): a
       prior init that cleared stickyScroll left the bar permanently off
       (translateY(110%), never .is-on) on mobile retests 2026-09-19. */
    if (stickyScroll) {
      window.removeEventListener('scroll', stickyScroll);
      window.removeEventListener('resize', stickyScroll);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', stickyScroll);
        window.visualViewport.removeEventListener('scroll', stickyScroll);
      }
      stickyScroll = null;
    }
    if (stickyIO) {
      stickyIO.disconnect();
      stickyIO = null;
    }

    var bar = $('#sticky');
    var cta = $('#cta');
    if (!bar || !cta) return;
    var finalSec = $('#s-final');

    function update() {
      var r = cta.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      /* Show once the main CTA has left the viewport (fully above). Lenient
         top check also covers partial scrapes where bottom never goes < 0
         because of mobile chrome / address-bar resize. */
      var ctaGone = r.bottom <= 0 || r.top + r.height * 0.5 < 0;
      /* With no closing CTA on the page, the bar just stays on past the buy box. */
      var belowFold = finalSec ? finalSec.getBoundingClientRect().top > vh * 0.35 : true;
      bar.classList.toggle('is-on', ctaGone && belowFold);
    }

    stickyScroll = update;
    window.addEventListener('scroll', stickyScroll, { passive: true });
    window.addEventListener('resize', stickyScroll, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', stickyScroll, { passive: true });
      window.visualViewport.addEventListener('scroll', stickyScroll, { passive: true });
    }

    if (typeof IntersectionObserver === 'function') {
      stickyIO = new IntersectionObserver(function () { update(); }, {
        root: null,
        threshold: [0, 0.01, 0.25, 0.5, 1]
      });
      stickyIO.observe(cta);
      if (finalSec) stickyIO.observe(finalSec);
    }

    update();
  }

  /* ---------- build-your-own-bundle band ----------

     Was a link to /pages/build-your-own-bundle. Now it builds the bundle in
     place and posts every line in ONE /cart/add.js call -- the same request the
     buy box makes, so Kaching's device ladder applies identically.

     WHAT THE LADDER ACTUALLY DOES
     Verified against the live cart on 2026-09-14: a cart of three different
     cameras took 5.00% off each line, and two cameras took 2.50%. So the ladder
     counts DEVICES ACROSS DIFFERENT PRODUCTS, not units of one product, and the
     discount lands in /cart.js rather than waiting for checkout.

     WHY THE SAVING IS CALLED AN ESTIMATE
     The percentages come from the rung blocks, which are hand-maintained copy.
     Kaching is the authority and can be changed in its admin without anyone
     touching this section. So the figure here is a forecast, the cart is the
     truth, and the wording says so. The alternative -- promising a number this
     file cannot enforce -- is the displayed-versus-charged trap the PDP brief
     spends a page on.

     Memory cards are deliberately left OUT of the discount estimate. Whether a
     card counts toward the device ladder is untested, so the estimate assumes
     it does not: under-promising is recoverable, over-promising is a refund. */
  function byob() {
    /* Every [data-byob] on the page, not just the first: the static redesign
       pages carry two layouts side by side while one is chosen, and each has
       to work on its own. Which is also why nothing below is looked up by id
       -- two instances would collide. */
    $$('[data-byob]').forEach(function (node) {
    once(node, function (root) {
      var items = $$('[data-bb-item]', root);
      if (!items.length) return;

      var addBtn = $('[data-bb-add]', root);
      var goBtn = $('[data-bb-checkout]', root);
      var addLabel = $('[data-bb-addlabel]', root);
      var grossEl = $('[data-bb-gross]', root);
      var netEl = $('[data-bb-net]', root);
      var saveEl = $('[data-bb-save]', root);
      var nudgeEl = $('[data-bb-nudge]', root);
      var itemsEl = $('[data-bb-items]', root);
      var emptyEl = $('[data-bb-empty]', root);
      var fillEl = $('[data-bb-fill]', root);
      var chips = $('[data-bb-chips]', root);
      var rungEls = $$('[data-bb-rungs] li', root);
      var presetEls = $$('[data-bb-preset]', root);
      var busy = false;

      var copy = {
        empty: addLabel ? addLabel.textContent : 'Choose your cameras',
        add: root.dataset.addLabel || 'Add {n} to cart',
        save: root.dataset.saveLabel || 'You save about {amt} ({pct})',
        next: root.dataset.nextLabel || 'Add {n} more to unlock {pct} off.',
        done: root.dataset.doneLabel || "You're on the best rate — {pct} off."
      };

      /* "2 devices"@"2.5%" -> { n: 2, pct: 2.5 }. Parsed from the rendered
         copy rather than stored as numbers, so the existing rung blocks keep
         working untouched. */
      var ladder = rungEls.map(function (li) {
        var half = (li.dataset.bbRung || '').split('@');
        return {
          n: parseFloat((half[0] || '').replace(/[^0-9.]/g, '')),
          pct: parseFloat((half[1] || '').replace(/[^0-9.]/g, ''))
        };
      }).filter(function (r) { return r.n > 0 && r.pct >= 0; });

      var top = ladder.length ? ladder[ladder.length - 1] : null;

      var cards = [];
      var cardData = $('[data-bb-carddata]', root);
      if (cardData) {
        try { cards = JSON.parse(cardData.textContent) || []; }
        catch (e) { console.warn('[kc3] byob: could not read the card sizes', e); }
      }
      /* One card slot per camera, each choosing its own capacity.

         A single size with a count cannot express what people actually buy:
         a 512 for the driveway and a 128 for the hallway is the normal case,
         not the exception. So the slots are generated from the cameras in the
         bundle and each carries its own choice, which also means the count can
         never disagree with the number of cameras it is meant to serve.

         Choices are keyed by slot position and survive a quantity change, so
         stepping a camera up and down again does not silently reshuffle the
         capacities already picked. */
      var slots = [];
      var slotWrap = $('[data-bb-slots]', root);
      var noCardLabel = (slotWrap && slotWrap.dataset.noCard) || 'No card';

      function rateFor(devices) {
        var pct = 0;
        for (var i = 0; i < ladder.length; i++) {
          if (devices >= ladder[i].n) pct = ladder[i].pct;
        }
        return pct;
      }

      function nextRung(devices) {
        for (var i = 0; i < ladder.length; i++) {
          if (devices < ladder[i].n) return ladder[i];
        }
        return null;
      }

      function qty(el) { return Number(el.dataset.qty || 0); }

      function counts() {
        var devices = 0, total = 0;
        items.forEach(function (el) {
          var q = qty(el);
          devices += q;
          total += q * Number(el.dataset.price || 0);
        });
        return { devices: devices, total: total };
      }

      /* Preset notes are worked out rather than typed, so a rung change in the
         theme editor cannot leave three hardcoded savings behind. */
      function priceOf(handleQty) {
        var devices = 0, total = 0;
        handleQty.forEach(function (pair) {
          var el = items[pair.i];
          if (!el) return;
          devices += pair.q;
          total += pair.q * Number(el.dataset.price || 0);
        });
        return { devices: devices, save: total * rateFor(devices) / 100 };
      }

      function parsePreset(spec) {
        return (spec || '').split('|').map(function (chunk) {
          var bits = chunk.split(':');
          var handle = (bits[0] || '').trim();
          var q = Number(bits[1] || 1) || 1;
          var i = -1;
          items.forEach(function (el, n) {
            if (el.dataset.handle === handle) i = n;
          });
          return { i: i, q: q };
        }).filter(function (x) { return x.i >= 0; });
      }

      function render() {
        var c = counts();
        var pct = rateFor(c.devices);
        var cardTotal = slots.reduce(function (a, c) { return a + (c ? Number(c.p || 0) : 0); }, 0);
        /* Cards are excluded from the estimate -- see the note above. */
        var saving = c.total * pct / 100;
        var gross = c.total + cardTotal;

        items.forEach(function (el) {
          var q = qty(el);
          el.classList.toggle('is-picked', q > 0);
          var out = $('[data-bb-value]', el);
          if (out) out.textContent = q;
        });

        var chosen = c.devices > 0 || cardTotal > 0;
        if (emptyEl) emptyEl.hidden = chosen;

        /* What is actually in the bundle. The totals say what it costs; without
           this the tile never says what you are buying. */
        if (itemsEl) {
          var cardCount = slots.filter(function (x) { return !!x; }).length;
          var parts = [];
          if (c.devices) parts.push(c.devices + (c.devices === 1 ? ' camera' : ' cameras'));
          if (cardCount) parts.push(cardCount + (cardCount === 1 ? ' memory card' : ' memory cards'));
          itemsEl.textContent = parts.join(' · ');
          itemsEl.hidden = !parts.length;
        }
        renderSlots();
        if (grossEl) grossEl.textContent = saving > 0 ? money(gross, 2) : '';
        if (netEl) netEl.textContent = chosen ? money(gross - saving, 2) : '';
        if (saveEl) {
          saveEl.hidden = saving <= 0;
          saveEl.textContent = copy.save
            .replace('{amt}', money(saving, 2))
            .replace('{pct}', pct + '%');
        }

        if (fillEl && top) {
          var pcnt = Math.min(c.devices / top.n, 1) * 100;
          fillEl.style.width = pcnt + '%';
        }
        rungEls.forEach(function (li, i) {
          var r = ladder[i];
          li.classList.toggle('is-on', !!r && c.devices >= r.n);
        });

        if (nudgeEl) {
          var nx = nextRung(c.devices);
          if (nx) {
            nudgeEl.hidden = false;
            nudgeEl.textContent = copy.next
              .replace('{n}', nx.n - c.devices)
              .replace('{pct}', nx.pct + '%');
          } else if (top && c.devices >= top.n) {
            nudgeEl.hidden = false;
            nudgeEl.textContent = copy.done.replace('{pct}', top.pct + '%');
          } else {
            nudgeEl.hidden = true;
          }
        }

        presetEls.forEach(function (b) {
          var spec = parsePreset(b.dataset.bbPreset);
          var on = spec.length > 0 && spec.every(function (x) {
            return qty(items[x.i]) === x.q;
          }) && spec.reduce(function (a, x) { return a + x.q; }, 0) === c.devices;
          b.classList.toggle('is-on', on);
          var note = $('[data-bb-preset-note]', b);
          if (note && !note.dataset.fixed) {
            var pr = priceOf(spec);
            if (pr.devices) {
              note.textContent = pr.devices + (pr.devices === 1 ? ' device' : ' devices')
                + (pr.save > 0 ? ' — save ' + money(pr.save, 2) : '');
            }
          }
        });

        var nothing = (c.devices === 0 && cardTotal === 0) || busy;
        if (addBtn) addBtn.disabled = nothing;
        if (goBtn) goBtn.disabled = nothing;
        if (addLabel) {
          addLabel.textContent = c.devices === 0
            ? copy.empty
            : copy.add.replace('{n}', c.devices + ' ' + (c.devices === 1 ? 'device' : 'devices'));
        }
      }

      items.forEach(function (el) {
        $$('[data-bb-step]', el).forEach(function (b) {
          b.addEventListener('click', function () {
            var next = qty(el) + Number(b.dataset.bbStep);
            el.dataset.qty = next < 0 ? 0 : next;
            render();
          });
        });
      });

      presetEls.forEach(function (b) {
        /* A typed note is left alone; an empty one is filled in by render(). */
        var note = $('[data-bb-preset-note]', b);
        if (note && note.textContent.trim()) note.dataset.fixed = '1';
        b.addEventListener('click', function () {
          var spec = parsePreset(b.dataset.bbPreset);
          if (!spec.length) return;
          items.forEach(function (el) { el.dataset.qty = 0; });
          spec.forEach(function (x) { items[x.i].dataset.qty = x.q; });
          render();
        });
      });

      /* A size with no variant id is priced but cannot be added, so it is
         offered disabled rather than silently dropped from the cart. */
      /* One entry per camera unit, carrying the largest card that camera can
         take. Only the Solar Cam Pro 3.0 reads a 512; everything else tops out
         at 256, so offering one would sell a card the camera cannot use. */
      function slotLabels() {
        var out = [];
        items.forEach(function (el) {
          var q = qty(el);
          for (var i = 0; i < q; i++) {
            out.push({ handle: el.dataset.handle || '', max: Number(el.dataset.maxcard) || 0 });
          }
        });
        return out;
      }

      function fits(c, max) {
        if (!max) return true;
        var gb = parseInt(c.s, 10);
        return !gb || gb <= max;
      }

      function nameFor(handle) {
        var n = '';
        items.forEach(function (el) {
          if (el.dataset.handle === handle) {
            var nm = $('[data-bb-name]', el);
            if (nm) n = nm.textContent;
          }
        });
        return n;
      }

      function renderSlots() {
        if (!slotWrap || !cards.length) return;
        var labels = slotLabels();
        slots.length = labels.length;

        /* The prompt is for an empty picker; once there are slots it is just
           a line contradicting the rows above it. */
        var emptyHint = $('[data-bb-slotsempty]', root);
        if (emptyHint) emptyHint.hidden = labels.length > 0;
        slotWrap.hidden = labels.length === 0;

        /* A slot's camera can change when quantities move, so a choice that no
           longer fits is dropped rather than left to reach the cart. */
        slots.forEach(function (c, i) {
          if (c && labels[i] && !fits(c, labels[i].max)) slots[i] = null;
        });

        while (slotWrap.children.length > labels.length) {
          slotWrap.removeChild(slotWrap.lastChild);
        }
        while (slotWrap.children.length < labels.length) {
          var i = slotWrap.children.length;
          var rowEl = document.createElement('label');
          rowEl.className = 'bb__slot';
          var who = document.createElement('span');
          who.className = 'bb__slot-for';
          var sel = document.createElement('select');
          sel.className = 'bb__slot-pick';
          sel.addEventListener('change', function () {
            var at = Array.prototype.indexOf.call(slotWrap.children, rowEl);
            var found = null;
            cards.forEach(function (c) { if (String(c.id) === sel.value) found = c; });
            slots[at] = found;
            render();
          });
          rowEl.appendChild(who);
          rowEl.appendChild(sel);
          slotWrap.appendChild(rowEl);
        }

        Array.prototype.forEach.call(slotWrap.children, function (rowEl, i) {
          var lab = labels[i] || { handle: '', max: 0 };
          var who = $('.bb__slot-for', rowEl);
          if (who) who.textContent = nameFor(lab.handle) || ('Camera ' + (i + 1));
          var sel = $('.bb__slot-pick', rowEl);
          if (!sel) return;

          /* Rebuild the list rather than hide what does not fit. option[hidden]
             is ignored by the native picker on iOS, which put a 512 in front of
             cameras that cannot read one. Rebuilt only when the limit actually
             changes, so picking a size does not rebuild under a shopper's
             finger mid-gesture. */
          if (rowEl.dataset.max !== String(lab.max)) {
            rowEl.dataset.max = String(lab.max);
            while (sel.firstChild) sel.removeChild(sel.firstChild);
            var none = document.createElement('option');
            none.value = '';
            none.textContent = noCardLabel;
            sel.appendChild(none);
            cards.forEach(function (c) {
              if (!fits(c, lab.max)) return;
              var o = document.createElement('option');
              o.value = c.id || '';
              o.textContent = c.s + ' · ' + money(Number(c.p), 0);
              if (!c.id) o.disabled = true;
              sel.appendChild(o);
            });
          }
          sel.value = slots[i] ? String(slots[i].id) : '';
        });
      }

      function lines() {
        var out = [];
        items.forEach(function (el) {
          var q = qty(el);
          if (q > 0) out.push({ id: Number(el.dataset.id), quantity: q });
        });
        var byId = {};
        slots.forEach(function (c) {
          if (c && c.id) byId[c.id] = (byId[c.id] || 0) + 1;
        });
        Object.keys(byId).forEach(function (id) {
          out.push({ id: Number(id), quantity: byId[id] });
        });
        return out;
      }

      /* One add path, two endings, the same shape the buy box uses:

           then: 'drawer'    add, then open the cart drawer
           then: 'checkout'  add, then go to checkout

         Express checkout is this and not a native payment button for the same
         reason it is in the buy box: a bundle is many line items and a
         cart-level discount, and the native button carries neither. */
      function send(opts) {
        var checkout = !!opts && opts.then === 'checkout';
        var trigger = checkout && goBtn ? goBtn : addBtn;
        if (busy || !trigger) return;
        var payload = lines();
        if (!payload.length) return;
        var error = $('[data-bb-error]', root);
        busy = true;
        trigger.setAttribute('aria-busy', 'true');
        if (addBtn) addBtn.disabled = true;
        if (goBtn) goBtn.disabled = true;
        if (error) error.hidden = true;

        /* Unqualified on purpose: assets/kc-cro.js wraps window.fetch to
           stamp the A/B arm onto cart adds, and a captured reference would
           route these around it. */
        var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: payload, sections: 'cart-drawer,kc-cart-json' })
          }).then(function (response) {
            return response.text().then(function (text) {
              var json = null;
              try { json = JSON.parse(text); } catch (e) { /* not JSON */ }
              if (!response.ok || !json) {
                throw new Error(
                  (json && (json.description || json.message))
                  || 'Could not add to cart (' + response.status + ' ' + response.statusText + ')'
                );
              }
              return json;
            });
        }).then(function (json) {
          if (checkout) {
            /* Leave `busy` set: the page is going away, and releasing it opens
               a window where a second tap adds the bundle again. */
            window.location.href = base + 'checkout';
            return;
          }
          refreshThenShowDrawer(null, null, drawerHtml(json), cartJson(json));
          items.forEach(function (el) { el.dataset.qty = 0; });
          slots.length = 0;
          busy = false;
          trigger.removeAttribute('aria-busy');
          render();
        }).catch(function (e) {
          /* A failed add never navigates: the shopper stays here with the
             reason rather than landing on a checkout without their bundle. */
          if (error) {
            error.textContent = e.message;
            error.hidden = false;
          }
          console.error('[kc3] byob add failed', e);
          busy = false;
          trigger.removeAttribute('aria-busy');
          render();
        });
      }

      if (addBtn) addBtn.addEventListener('click', function () { send({ then: 'drawer' }); });
      if (goBtn) goBtn.addEventListener('click', function () { send({ then: 'checkout' }); });

      /* The kits sit in a dialog, opened from the row below the builder.
         <dialog> rather than a div: Esc, the backdrop and focus trapping come
         free and none of it has to be written here. */
      var kitsModal = $('[data-bb-kitsmodal]', root);
      if (kitsModal) {
        $$('[data-bb-kitsopen]', root).forEach(function (b) {
          b.addEventListener('click', function () {
            if (typeof kitsModal.showModal === 'function') kitsModal.showModal();
            else kitsModal.setAttribute('open', '');
          });
        });
        $$('[data-bb-kitsclose]', kitsModal).forEach(function (b) {
          b.addEventListener('click', function () { kitsModal.close(); });
        });
        /* A backdrop click lands on the dialog itself, never on its contents. */
        kitsModal.addEventListener('click', function (e) {
          if (e.target === kitsModal) kitsModal.close();
        });
      }

      /* Ready-made kits are real products with their own variant, not a
         preset that fills the builder: the kit is priced as a unit and the
         saving is already in that price, so seeding the picker from it would
         quote a different number than the cart charges. One button, one line. */
      $$('[data-bb-kit]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          if (busy) return;
          var id = Number(b.dataset.bbKit);
          if (!id) return;
          busy = true;
          b.setAttribute('aria-busy', 'true');
          var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,kc-cart-json' })
          }).then(function (response) {
            return response.text().then(function (text) {
              var json = null;
              try { json = JSON.parse(text); } catch (e) { /* not JSON */ }
              if (!response.ok || !json) {
                throw new Error((json && (json.description || json.message))
                  || 'Could not add to cart (' + response.status + ')');
              }
              return json;
            });
          }).then(function (json) {
            refreshThenShowDrawer(null, null, drawerHtml(json), cartJson(json));
          }).catch(function (e) {
            var err = $('[data-bb-kiterror]', b.closest('[data-bb-kitcard]') || root);
            if (err) { err.textContent = e.message; err.hidden = false; }
            console.error('[kc3] kit add failed', e);
          }).then(function () {
            busy = false;
            b.removeAttribute('aria-busy');
            render();
          });
        });
      });

      render();
    });
    });
  }

  function init() {
    /* Each behaviour is isolated: a throw in byob/cost/etc. previously aborted
       init before sticky() ran, leaving #sticky at translateY(110%) forever. */
    var steps = [
      buybox, addToCart, sticky,
      delivery, gallery, rails, clips, video,
      cost, stars, faq, appRail, byob
    ];
    for (var i = 0; i < steps.length; i++) {
      try { steps[i](); }
      catch (err) { console.error('[kc3] init step failed', steps[i].name || i, err); }
    }
  }

  window.KC3 = { $: $, $$: $$, money: money, trim: trim, init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor: a re-rendered section arrives with no listeners attached. */
  document.addEventListener('shopify:section:load', init);
})();
